/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by jesse on 5/6/16.
 */
'use strict';
angular.module('prism-ui.components').service('PackagePropertiesQueryService',
	function ($q, ContentResourceFactory, NetworkResourceFactory, PackageResourceFactory) {
		var PackagePropertiesQueryService = this;
		var CONTENT_TYPES = ['Ad/PreRoll', 'Movie/Special', 'Series'];
		var retrievedContents = {};
		var retrievedContentsExtended = {}; // holds series with seasons volumes

		PackagePropertiesQueryService.getNetworks = function () {
			var defferred = $q.defer();
			NetworkResourceFactory.getNetworks({fetchLimit: 1000000}).$promise.then(function (networks) {
				defferred.resolve(networks);
			});
			return defferred.promise;
		};

		PackagePropertiesQueryService.getContentTypes = function () {
			var defferred = $q.defer();
			defferred.resolve(CONTENT_TYPES);
			return defferred.promise;
		};

		PackagePropertiesQueryService.getSeasonsVolumesForContents = function(contents) {
			var defferred = $q.defer();
			var retrivedContents = [];
			var promises = {};
			angular.forEach(contents, function (content) {
				var seasonsVolumes = retrievedContentsExtended[content.id];
				if (seasonsVolumes) {
					retrivedContents = retrivedContents.concat(seasonsVolumes);
				}
				else {
					promises[content.id] = ContentResourceFactory.get({id: content.id}).$promise;
				}
			});

			$q.all(promises).then(function (data) {
				angular.forEach(data, function (content, contentID) {
					retrievedContentsExtended[contentID] = content;
					retrivedContents.push(content);
				});
				defferred.resolve(angular.copy(retrivedContents));
			});

			return defferred.promise;
		};

		PackagePropertiesQueryService.getContents = function (type) {
			var defferred = $q.defer();

			if (retrievedContents[type]) {
				defferred.resolve(retrievedContents[type]);
			}
			else {
				var params = {type: type, fetchLimit: 1000000, view: 'MINIMAL'};
				ContentResourceFactory.query({}, params).$promise.then(function (contents) {
					retrievedContents[type] = contents;
					defferred.resolve(contents);
				});
			}
			return defferred.promise;
		};

		PackagePropertiesQueryService.getCategories = function () {
			return PackageResourceFactory.getCategories({}, {view: 'EXTENDED'}).$promise;
		};
	});
